module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "slide",
    staticClass: "slide",
    style: ({
      height: _vm.itemHeight + 'px',
      width: _vm.width
    })
  }, [_c('div', {
    ref: "slidecontent",
    staticClass: "slide-content animate-hack",
    style: ({
      width: _vm.fullWidth + 'px'
    })
  }, [_vm._l((_vm.surface), function(item) {
    return _c('slide-item', {
      attrs: {
        "imgUrl": item.imgUrl,
        "width": (_vm.itemWidth + "px"),
        "height": (_vm.itemHeight + "px")
      }
    })
  }), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "slide-btns"
  }, _vm._l((_vm.surface), function(item, key, index) {
    return _c('button', {
      staticClass: "slide-btn",
      class: [key === _vm.currentIndex ? 'slide-btn-current' : '']
    })
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03dec8ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slide/slide.vue
// module id = 54
// module chunks = 2 12